export const environment = {
  production: false,
  name: 'preprod',
  projectName: 'RUBi',
  defaultTheme: 'RUBi',
  version: '1.1.2',
  region: 'us-gov-west-1',
  url: 'https://rubi-preprod.cristlgov.com',
  endpoint: 'https://rubi-be-preprod.cristlgov.com',
  sandboxEnabled: false,
  uamUrl: 'https://preprod.cristlgov.com/',
  refreshEndpoint: 'https://preprod-be.cristlgov.com/auth/refreshToken',
  boardsEnabled: false,
  cookieInfo: {
    domain: '.cristlgov.com',
  }
};
